import { Icon } from '@types';

export const Notification = ({ customStyles, handleClick }: Icon) => {
	return (
		<svg
			className={customStyles}
			onClick={handleClick}
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 100 100"
			xmlSpace="preserve"
		>
			<g>
				<path d="M49.9,90c5.2,0,9.9-4.5,10.1-9.9l-4-0.2c-0.1,3.2-3,6.1-6.1,6.1c-3,0-5.8-2.8-5.9-6.1l-4,0.2C40.2,85.5,44.8,90,49.9,90z" />
				<path d="M71.6,39.5c0-8.8-5.1-16.8-12.8-20.4c0-0.3,0.1-0.7,0.1-1.1c0-5-4-9-9-9c-4.9,0-8.8,4-8.8,9c0,0.4,0,0.7,0.1,1.1   c-7.7,3.6-12.8,11.6-12.8,20.4c0,10.4-2.8,16.9-10.8,24.9c-3.3,3.3-2.8,6.2-2.2,7.7c1.3,3.1,5,5,9.8,5h49.7c4.8,0,8.5-1.9,9.8-5   c0.6-1.4,1.1-4.4-2.2-7.7C74.5,56.4,71.6,49.9,71.6,39.5z M81,70.5c-0.5,1.2-2.6,2.5-6.1,2.5H25.1c-3.5,0-5.6-1.3-6.1-2.5   c-0.5-1.2,0.6-2.6,1.4-3.3c8.7-8.7,12-16.2,12-27.7c0-7.7,4.7-14.7,11.8-17.4l1.8-0.7l-0.6-1.8c-0.2-0.5-0.3-1.1-0.3-1.6   c0-2.8,2.1-5,4.8-5c2.8,0,5,2.2,5,5c0,0.5-0.1,1.1-0.3,1.6L54,21.4l1.8,0.7c7.1,2.6,11.8,9.6,11.8,17.4c0,11.5,3.2,19,12,27.7   C80.3,67.9,81.5,69.3,81,70.5z" />
				<path d="M79.2,31.7l3.7-1.5c-2-4.8-4.7-9-8.1-12.5c-1.9-2-4.1-3.8-6.4-5.3l-2.2,3.3c2.1,1.4,4,3,5.7,4.8   C74.9,23.7,77.4,27.5,79.2,31.7z" />
				<path d="M33.9,15.7l-2.2-3.3c-6.4,4.2-11.4,10.4-14.5,17.8l3.7,1.5C23.7,25,28.2,19.5,33.9,15.7z" />
			</g>
		</svg>
	);
};
